module.exports = __webpack_public_path__ + "img/row-discharging-start.cf62640d.png";